import classNames from 'classnames';
import React, { useEffect, useRef, useState } from 'react';
import Login from './Login';
import { ReactComponent as LoginUndraw } from 'assets/svg/undraw-login.svg';
import { ReactComponent as RegisterUndraw } from 'assets/svg/undraw-register.svg';
import SignUp from './SignUp';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { oauthGoogle } from 'store/reducers/auth';
import configEnv from 'env';

const Authen = () => {
  const [login, setLogin] = useState(true);
  const { isAuthenticated } = useSelector((state) => state.auth);
  const firstRender = useRef(true);
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const location = useLocation();
  const btnRef = useRef();
  const btnSignUp = useRef();
  const loadSuccess = useRef(false);
  const dispatch = useDispatch();

  const onChangeTab = () => {
    setLogin(!login);
    if (login) {
      navigate('/auth/register');
    } else {
      navigate('/auth/login');
    }

    firstRender.current = false;
  };

  function onCallbackLoginGoogle(response) {
    dispatch(oauthGoogle(response.credential));
  }

  const initGoogle = () => {
    window.google.accounts.id.initialize({
      client_id: configEnv.google.client_id,
      callback: onCallbackLoginGoogle,
      context: 'use',
    });

    window.google.accounts.id.renderButton(
      btnRef.current,
      { theme: 'outline', size: 'large' } // customization attributes
    );

    window.google.accounts.id.renderButton(
      btnSignUp.current,
      { theme: 'outline', size: 'large', context: 'signup' } // customization attributes
    );
    window.google.accounts.id.prompt(); // also display the One Tap dialog
    loadSuccess.current = true;
  };

  useEffect(() => {
    if (loadSuccess.current) {
      window.google.accounts.id.prompt();
    } else {
      window.onload = initGoogle;
    }
    // eslint-disable-next-line
  }, [login]);

  useEffect(() => {
    if (firstRender.current) {
      if (pathname.includes('login')) {
        setLogin(true);
      } else {
        onChangeTab();
      }
    }
    // eslint-disable-next-line
  }, [pathname]);

  if (isAuthenticated) {
    return navigate(location?.state?.from || '/', { replace: true });
  }

  return (
    <div className="authen">
      <div
        className={classNames('authen__left', {
          leftToRight: !login && !firstRender.current,
          rightToLeft: login && !firstRender.current,
        })}
      >
        <div className={classNames('authen__form-wraper')}>
          <Login ref={btnRef} onChangeTab={onChangeTab} />
        </div>
        <div className={classNames('authen__image')}>
          <RegisterUndraw />
        </div>
      </div>
      <div
        className={classNames('authen__right', {
          leftToRight: login && !firstRender.current,
          rightToLeft: !login && !firstRender.current,
        })}
      >
        <div className={classNames('authen__form-wraper')}>
          <SignUp ref={btnSignUp} onChangeTab={onChangeTab} />
        </div>
        <div className={classNames('authen__image')}>
          <LoginUndraw />
        </div>
      </div>
    </div>
  );
};

export default Authen;
